import React from "react";
import { ProductContainer } from "./style";
import { FiChevronLeft } from "react-icons/fi";
import NumberFormat from "components/numberFormat";
const ProductBox = ({ item, select,showPic }) => {
  console.log("itemitemitemitemitem",item.item.car_model);
  return (
    <ProductContainer>
      <div className="image">
        <img src={`./images/${item.item.car_model}/${showPic}.jpg`} alt="product" />
      </div>
      <div className="content">
        <div className="title-area">
          <h5>{item?.item.title}
            <br/>
            <small>{item?.item.desc}</small>
          </h5>

          <span className="number">کد طرح فروش : {item?.reference}</span>
        </div>
        <div className="labels">
          <div className="label">{item?.title}</div>
          <div className="label">{item?.price_note}</div>
        </div>
        <div className="description" dangerouslySetInnerHTML={{ __html: item?.item.description}} />
        <div className="date">{item?.delivery_note}</div>
        {/* <ul className="colors">
          {item.item.options.color.map((color) => (
            <li key={color.id} style={{ backgroundColor: color.code }}></li>
          ))}
        </ul> */}
      </div>
      <div className="price" onClick={() => select(item)}>
        <div className="data">
          <span>مبلغ قابل پرداخت</span>
          <span className="amount">
            <NumberFormat value={item?.price} />
          </span>
        </div>
        <FiChevronLeft className="icon" />
      </div>
    </ProductContainer>
  );
};
const checkEquality = (prevProps, nextProps) => {
  if (prevProps.item.id !== nextProps.item.id) {
    return false;
  }
  return true;
};
export default React.memo(ProductBox, checkEquality);
